"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props) {
  var palette = theme.palette,
      iconTransform = 'scale(0)',
      iconOpacity = 1,
      cursor = 'pointer',
      appearanceMargin = theme.appearanceMargin;

  if (props.checked) {
    // backward compatibility
    theme.color = theme.checkedColor || theme.activeColor;
    iconTransform = 'scale(1)';
  }

  if (props.error) {
    theme.color = theme.errorColor;
  }

  if (props.disabled) {
    theme.color = theme.disabledColor;
    theme.hoverColor = theme.disabledColor;
    iconOpacity = 0.5;
    cursor = 'not-allowed';
  }

  if (!props.children && !props.label) {
    appearanceMargin = 0;
  }

  var iconStyles = {
    width: theme.appearanceWidth,
    height: theme.appearanceHeight,
    opacity: iconOpacity,
    transitionProperty: 'background, opacity',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction
  };
  var multilineStyles = {};

  if (props.multiline) {
    multilineStyles = {
      whiteSpace: 'normal',
      wordBreak: 'break-word'
    };
  }

  return {
    root: {
      display: theme.display
    },
    wrapper: {
      position: 'relative',
      font: "".concat(palette.tsNormal, "/").concat(palette.tlNormal, " \"").concat(theme.fontFamily, "\""),
      color: theme.color,
      zoom: 1
    },
    description: {
      color: theme.labelColor,
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      width: '100%',
      textAlign: 'left'
    },
    field: {
      display: 'none'
    },
    label: {
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      cursor: cursor,
      display: 'flex',
      alignItems: 'center',
      color: theme.color,
      transitionProperty: 'color',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      '& a': {
        color: theme.color
      },
      '&:hover': {
        color: theme.hoverColor
      }
    },
    labelWrapper: {},
    labelText: _objectSpread({
      paddingRight: theme.paddingRight,
      paddingBottom: theme.paddingBottom,
      paddingTop: theme.paddingTop,
      paddingLeft: theme.paddingLeft,
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight
    }, multilineStyles),
    iconStyles: iconStyles,
    icon: _objectSpread({}, iconStyles, {
      position: 'relative',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain'
    }, theme.idleIconFx, {
      '&:hover': theme.hoverIconFx
    }),
    checkedIcon: _objectSpread({}, iconStyles, {
      transition: 'all 250ms cubic-bezier(1, 1.7, 0, 1) 0ms',
      display: 'block',
      content: '""',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      position: 'absolute',
      transform: iconTransform,
      top: 0,
      left: 0
    }),
    iconWrapper: {
      position: 'relative',
      margin: appearanceMargin
    }
  };
}